import styled from "styled-components";
import Box from "../../Styled/Box";
export const PrefaceBox = styled(Box).withConfig({
  displayName: "PrefaceBox",
  componentId: "sc-14vwn7g-0"
})(["position:fixed;width:100%;height:100%;background:", ";z-index:1000;opacity:", ";"], p => p.pseudoBg ? "black" : "transparent", p => p.pseudoBg ? 0.45 : 1);